<div class="seperator"></div>
<div class="title" mat-dialog-title>Select Customer ID</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple Customer IDs from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Customer ID</mat-label>
            <mat-select multiple [formControl]="gadsCustomerIds">
                <mat-option *ngFor="let customer of data.userProfilesOrAgencies" [value]="customer.id + ''">
                    {{customer.id + ' - ' + customer.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>